module.exports = __webpack_public_path__ + "img/technology2.5204a163.png";